import { fmtDate } from '@jt/core';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { del, get, post } from '../api/client';
import { ConfirmButton, useUI } from '../components/overlays';

interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  createdAt: string;
  lastUsedAt: string | null;
}

const key = ['api-keys'] as const;

/** Ключи для POST /api/inbox/ingest (n8n и свои скрипты). Сам ключ показывается один раз. */
export function ApiKeysBox() {
  const qc = useQueryClient();
  const ui = useUI();
  const list = useQuery({ queryKey: key, queryFn: () => get<ApiKey[]>('/settings/api-keys') });
  const [fresh, setFresh] = useState<string | null>(null);
  return (
    <section className="box" id="api-keys">
      <h2>Вход для n8n и скриптов</h2>
      <p className="muted sm" style={{ marginTop: -6 }}>
        <code>POST /api/inbox/ingest</code> с заголовком <code>X-Api-Key</code> и телом{' '}
        <code>{'{ text, source, externalId }'}</code> — текст разберёт Claude, событие появится во «Входящих».
        Пример сценария — <code>docs/n8n/ingest.json</code>.
      </p>
      {fresh && (
        <div className="pform" role="status">
          <b>Новый ключ — скопируйте сейчас, потом он не покажется:</b>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', margin: '8px 0 0' }}>{fresh}</pre>
        </div>
      )}
      {list.data?.length ? (
        <div className="list" style={{ marginBottom: 10 }}>
          {list.data.map((k) => (
            <div className="lrow" key={k.id}>
              <div className="lm">
                <b>{k.name}</b> <span className="muted">{k.prefix}…</span>
                <div className="meta">
                  создан {fmtDate(k.createdAt.slice(0, 10))}
                  {k.lastUsedAt
                    ? ` · использован ${fmtDate(k.lastUsedAt.slice(0, 10))}`
                    : ' · ещё не использовался'}
                </div>
              </div>
              <ConfirmButton
                className="btn sm ghost danger"
                confirmText="Отозвать?"
                onConfirm={async () => {
                  await del(`/settings/api-keys/${k.id}`);
                  await qc.invalidateQueries({ queryKey: key });
                  ui.toast('Ключ отозван');
                }}
              >
                Отозвать
              </ConfirmButton>
            </div>
          ))}
        </div>
      ) : null}
      <button
        className="btn sm"
        onClick={async () => {
          const r = await post<ApiKey & { key: string }>('/settings/api-keys', { name: 'n8n' });
          setFresh(r.key);
          await qc.invalidateQueries({ queryKey: key });
        }}
      >
        Создать ключ
      </button>
    </section>
  );
}
